export const placesDo = [
  {
    name: "Point Reyes National Park",
    body: "Beautiful hikes along beaches and cliffs, open grasslands, and forested ridges.",
    url: "www.nps.gov/pore/planyourvisit/hiking_guide.htm"
  },
  {
    name: "Kayak Rental",
    body: "",
    url: "enjoy-napa-valley.com/napa-kayak-tours"
  },
  {
    name: "Bike Rental",
    body: "",
    url: "www.naparivervelo.com"
  },
  {
    name: "The Culinary Institute of America",
    body: "The two campuses, CIA at Greystone (St. Helena) and CIA at Copia (Napa) include restaurants, demonstrations, classes, and excellent shops.",
    url: "ciachef.edu/cia-california/"
  },
  {
    name: "Indian Springs Calistoga Spa",
    body: "Visit the famous Indian Springs mud and mineral baths.",
    url: "indianspringscalistoga.com"
  },
  {
    name: "Napa Farmer’s Market",
    body: "Tuesdays and Saturdays from 8 am to 12:30 pm at 195 Gasser Drive, Napa, CA 94559",
    url: "napafarmersmarket.org"
  }
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/thingsToDo/placesDo.ts